/* Decode the first scene, then open the curtain and release its typography. */
(() => {
  'use strict';
  const root=document.documentElement, entry=window.RGCEntry;
  if(!entry||entry.done)return;
  const cover=document.querySelector('.rgc-entry');
  if(!cover){entry.finish();return;}
  root.classList.add('rgc-entry-mounted');
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const animations=[];
  const delay=ms=>new Promise(resolve=>setTimeout(resolve,ms));
  const bounded=(work,ms)=>Promise.race([work,delay(ms)]);
  const decode=async image=>{
    if(!image.complete)await new Promise(resolve=>{image.addEventListener('load',resolve,{once:true});image.addEventListener('error',resolve,{once:true});});
    if(image.naturalWidth&&image.decode)await image.decode().catch(()=>{});
  };
  const nativeReady=new Promise(resolve=>{
    if(!root.classList.contains('is-loading')){resolve();return;}
    const observer=new MutationObserver(()=>{if(!root.classList.contains('is-loading')){observer.disconnect();resolve();}});
    observer.observe(root,{attributes:true,attributeFilter:['class']});
    setTimeout(()=>{observer.disconnect();resolve();},6500);
  });
  const animate=(element,frames,duration,wait=0)=>{
    if(!element||!element.animate)return Promise.resolve();
    const animation=element.animate(frames,{duration,delay:wait,easing:'cubic-bezier(.76,0,.24,1)',fill:'both'});
    animations.push(animation);return animation.finished.catch(()=>{});
  };
  const cleanup=()=>{animations.forEach(a=>a.cancel());entry.finish();};
  const start=async()=>{
    const scene=document.querySelector('.hero,.mk-hero,.cover');
    const photos=scene?[...scene.querySelectorAll('img')].filter(img=>img.loading!=='lazy').slice(0,3):[];
    await Promise.all([bounded(Promise.allSettled(photos.map(decode)),5000),bounded(document.fonts?.ready||Promise.resolve(),1500),nativeReady,delay(reduced.matches?0:260)]);
    if(entry.done)return;
    if(reduced.matches||!cover.animate){cleanup();return;}
    root.classList.add('rgc-entry-opening');
    const mode=root.dataset.entryMode;
    const panels=[...cover.querySelectorAll('.rgc-entry-panel')];
    animate(cover.querySelector('.rgc-entry-mark'),[{opacity:1,transform:'translateY(0)'},{opacity:0,transform:'translateY(-12px)'}],240);
    const opening=panels.map((panel,i)=>animate(panel,[{transform:'translate3d(0,0,0)'},{transform:mode==='split'?`translate3d(${i?102:-102}%,0,0)`:'translate3d(0,-102%,0)'}],1000,i*85+90));
    await delay(310);
    entry.reveal();
    // Individual transform properties do not overwrite the page's scroll transforms.
    if(scene&&scene.getBoundingClientRect().top<innerHeight&&scrollY<innerHeight*.6){
      const copy=scene.querySelector('.hero-emblem,.logo-content,.hero-inner,.hero-content');
      if(copy)animate(copy,[{opacity:0,translate:'0 20px',clipPath:'inset(0 0 100% 0)'},{opacity:1,translate:'0 0',clipPath:'inset(0 0 0% 0)'}],980,40);
      const photo=scene.querySelector('.hero-background,.cover-art');
      if(photo)animate(photo,[{scale:'1.025'},{scale:'1'}],1400);
    }
    await Promise.all(opening);
    root.classList.remove('rgc-entry-pending','rgc-entry-mounted','rgc-entry-opening');
    cover.remove();
    // Let any longer photo settling finish before clearing its temporary effects.
    await Promise.all(animations.map(a=>a.finished.catch(()=>{})));
    cleanup();
  };
  reduced.addEventListener('change',()=>{if(reduced.matches)cleanup();});
  addEventListener('pageshow',event=>{if(event.persisted)cleanup();});
  start().catch(cleanup);
})();
